export const GET_BEDS = 'Get_Beds';